export type CourseFilterTagT = 'course-filters'
export const COURSE_FILTER_TAG: CourseFilterTagT = 'course-filters'
